export default __webpack_public_path__ + "static/media/gallery449_4.26739e09.png";